import { EventViewPage } from 'pages/EventViewPage';
import FormEditPage from 'pages/FormEditPage';
import FormSubmissionsPage from 'pages/FormSubmissionsPage';
import { GuideIntegrationPage } from 'pages/GuideIntegrationPage';

import { GuideLandingPage } from 'pages/GuideLandingPage';
import { LandingRedirect } from 'pages/LandingRedirect';
import { OsloDesignFairPage } from 'pages/OsloDesignFair';
import { ViewMapPage } from 'pages/ViewMapPage';
import { ViewMapPageV2 } from 'pages/ViewMapPageV2';
import { CustomerPages } from 'pages/custom/CustomerPages';
import { EmbedPage } from 'pages/custom/EmbedPage';
import EventUserQuickEditPage from 'pages/quickEdit/EventUserQuickEditPage';
import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router';
import { useRouterListener } from 'static/routes/sub/RouterListener';
import RoutesAccess from 'static/routes/sub/RoutesAccess';
import RoutesMinute from 'static/routes/sub/RoutesMinute';
import RoutesSpecial from 'static/routes/sub/RoutesSpecial';

const GuideAdminPage = lazy(() => import('pages/GuideAdminPage'));

const Suspensed = (props: { children: React.ReactNode }) => (
    <Suspense fallback={<></>}>{props.children}</Suspense>
);

export const MapheimRouter = () => {
    useRouterListener();

    return (
        <>
            <Routes>
                {RoutesSpecial}
                {RoutesMinute}
                {RoutesAccess}

                {/* Map routes */}
                <Route path="/event/:eventId/*" element={<EventViewPage />} />
                <Route path="/m/:customId/:detailId?" element={<CustomerPages />} />
                <Route path="/map/:id/:detailId?" element={<ViewMapPage />} />
                <Route
                    path="map2/b1c9e939-6d3b-4025-b432-e5c9b78c0038/:detailId?"
                    element={<OsloDesignFairPage />}
                />
                <Route
                    path="map2/8455e5ae-a046-40af-a057-ad2e9899e3ee/:detailId?"
                    element={<OsloDesignFairPage />}
                />
                <Route path="map2/:id/:detailId?" element={<ViewMapPageV2 />} />

                <Route path="/admin" element={<GuideLandingPage />} />
                <Route path="/admin/integration" element={<GuideIntegrationPage />} />
                <Route
                    path="/admin/:guideId/*"
                    element={
                        <Suspensed>
                            <GuideAdminPage />
                        </Suspensed>
                    }
                />

                {/* Embed routes */}
                <Route path="/embed/:eventId/*" element={<EmbedPage />} />

                <Route
                    path="/form/:eventFormId/submissions"
                    element={
                        <Suspensed>
                            <FormSubmissionsPage />
                        </Suspensed>
                    }
                />

                <Route
                    path="/form/:eventFormId/edit"
                    element={
                        <Suspensed>
                            <FormEditPage />
                        </Suspensed>
                    }
                />

                <Route
                    path="/quick-edit/event-user/:eventId/:userId/:token"
                    element={<EventUserQuickEditPage />}
                />

                <Route path="*" element={<LandingRedirect />} />
            </Routes>
        </>
    );
};
